import { render, staticRenderFns } from "./guide_set.vue?vue&type=template&id=4b79a6fa&scoped=true"
import script from "./guide_set.vue?vue&type=script&lang=ts"
export * from "./guide_set.vue?vue&type=script&lang=ts"
import style0 from "./guide_set.vue?vue&type=style&index=0&id=4b79a6fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b79a6fa",
  null
  
)

export default component.exports